export default __webpack_public_path__ + "static/products-e9e48322dfb0e553366763e4ef282625.jpg";